<template>
  <p
    :is="tag"
    v-if="state"
    :class="classes"
  >
    <template v-if="loading">
      <context-loading class="cordel-state-animation" />

      <slot name="loading">
        Carregando...
      </slot>
    </template>

    <template v-if="notfound">
      <img
        :src="illustration"
        alt="404"
        class="cordel-state-illustration"
      >

      <slot name="notfound">
        Não encontramos o que você está procurando :(
      </slot>
    </template>

    <template v-if="error">
      <slot name="error">
        Algo deu errado! :(
      </slot>
    </template>

    <template v-if="empty">
      <slot name="empty">
        Sem mais resultados
      </slot>
    </template>
  </p>
</template>

<script>
  import illustration from '@cordel/assets/images/illustrations/404.jpg';

  import ContextLoading from '@cordel/components/Context/Loading.vue';

  const STATES = ['loading', 'notfound', 'error', 'empty'];

  export default {
    name: 'ContextState',
    components: {
      ContextLoading,
    },
    props: {
      state: {
        type: String,
        default: null,
        validator(value) {
          return STATES.includes(value);
        },
      },
      tag: {
        type: String,
        default: 'section',
      },
    },
    data() {
      return {
        illustration,
      };
    },
    computed: {
      loading() {
        return this.state === 'loading';
      },
      notfound() {
        return this.state === 'notfound';
      },
      error() {
        return this.state === 'error';
      },
      empty() {
        return this.state === 'empty';
      },

      classes() {
        return [
          'cordel-state',
          `variant--${this.state}`,
        ];
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .cordel-state {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: var(--cordel-legacy-spacing-blaster) 0 0;
    text-align: center;
  }

  .cordel-state-animation {
    margin-right: var(--cordel-legacy-spacing-xxxs);
  }

  .cordel-state-illustration {
    display: block;
    margin: 0 auto var(--cordel-legacy-spacing-giga);
    max-width: 250px;
    width: 100%;
  }

  .variant--notfound {
    flex-direction: column;
  }

  .variant--error {
    color: var(--cordel-legacy-color-alert-danger);
  }
</style>
